// extracted by mini-css-extract-plugin
module.exports = {"menu":"PackagesContainer_menu__Si82w","tab":"PackagesContainer_tab__VtgfM","active":"PackagesContainer_active__aOHdM"};